<app-input-select
  idField="idArera"
  labelField="denominazione"
  [list]="areraGestore"
  [name]="name"
  label="ARERA Gestore"
  icon="stars"
  [form]="form"
  [searchComponentTemplate]="searchTemplate"
></app-input-select>
